import { render, staticRenderFns } from "./goal-survey-statistics.vue?vue&type=template&id=3d153de7"
import script from "./goal-survey-statistics.vue?vue&type=script&lang=ts"
export * from "./goal-survey-statistics.vue?vue&type=script&lang=ts"
import style0 from "./goal-survey-statistics.vue?vue&type=style&index=0&id=3d153de7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports